/**
 * PromotionCtrl controller
 */
import { MOVIE_OF_THE_NIGHT_COUNTRIES } from '../../app/core/constants'

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

// controller mixins
PromotionCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * PromotionCtrl controller
 *
 * @class PromotionCtrl
 * @memberof mwApp/packages
 * @see mwApp/promotion
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/promotion.controller:PromotionCtrl
 */
/* @ngInject */
export default function PromotionCtrl ($scope, $uibModal, $http, $location, pckg, Shelf, Banner, BannerBundle, Featured, FeaturedCarousel, NetworkRow, MovieOfTheNight, authSvc, alertLiteSvc, cts, bannerSubscriptions, featuredSubscriptions, scope, motn) {
  var vm = this

  vm.postersIsOpen = true

  vm.motn = motn

  /** Preserves MOTN API key when the UI masks the field (edit disabled). */
  const motnApiKeyAtLoad = motn && angular.isDefined(motn.apiKey) ? motn.apiKey : ''

  vm.countries = Object.fromEntries(
    Object.entries(MOVIE_OF_THE_NIGHT_COUNTRIES).sort(([, nameA], [, nameB]) => nameA.localeCompare(nameB))
  )

  /**
   * Network
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg

  /**
   * Base Banners list
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   * @type {[models.Banner]}
   */
  vm.carousels = []

  vm.updatedBC = false
  vm.updatedFR = false

  /**
   * Platforms array
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   * @type {Object[]}
   */

  /**
   * Default values for table state
   *
   * @type {Object}
   */
  const defaultTableState = {
    page: 0,
    count: 5,
    name: '',
    last: false
  }

  // copy for table state
  vm.bannersState = angular.copy(defaultTableState)

  // load banner info
  Banner.loadAll({ networkId: vm.pckg.id, params: vm.bannersState }).then((result) => {
    vm.loadedBanner = true
    vm.carousels = result.content.map((ba) => {
      ba.networkId = vm.pckg.id // Hack! set networkId to banner bundle

      ba.bannerBundles.map((bb) => { // mixin ids
        bb.networkId = vm.pckg.id
        return bb
      })

      ba.$listOfSubscriptions = angular.copy(bannerSubscriptions.filter(s => !ba.subscriptions.find(sub => sub.id === s.id)))
      if (ba.$listOfSubscriptions.length) {
        ba.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(ba.$listOfSubscriptions)
      } else {
        ba.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
      }

      return new Banner(ba)
    })
    vm.bannersState.last = result.last
  })

  vm.toggleBannerShowAll = function () {
    vm.showAllBanners = !vm.showAllBanners
    if (!vm.bannersState.last) {
      Banner.loadAll({ networkId: vm.pckg.id, params: { ...vm.bannersState, count: 100 } }).then((result) => {
        vm.loadedBanner = true
        vm.carousels = vm.carousels.concat(result.content.map((ba) => {
          ba.networkId = vm.pckg.id // Hack! set networkId to banner bundle

          ba.bannerBundles.map((bb) => { // mixin ids
            bb.networkId = vm.pckg.id
            return bb
          })

          ba.$listOfSubscriptions = angular.copy(bannerSubscriptions.filter(s => !ba.subscriptions.find(sub => sub.id === s.id)))
          if (ba.$listOfSubscriptions.length) {
            ba.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(ba.$listOfSubscriptions)
          } else {
            ba.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
          }

          return new Banner(ba)
        }).filter(ba => {
          return !vm.carousels.find(c => c.id === ba.id)
        }))
        vm.bannersState.last = result.last
      })
    }
  }

  vm.addBannerCarousel = function () {
    let subscriptionsForBanner
    if (!vm.carousels.length) {
      subscriptionsForBanner = [{ id: 0, name: 'All Subscriptions' }].concat(bannerSubscriptions)
    } else {
      if (vm.carousels[0].$listOfSubscriptions.filter(s => s.id > 0).length) {
        subscriptionsForBanner = angular.copy(vm.carousels[0].$listOfSubscriptions)
      } else {
        subscriptionsForBanner = []
      }
    }
    vm.carousels.unshift(new Banner({
      $listOfSubscriptions: subscriptionsForBanner,
      networkId: vm.pckg.id,
      $action: 'post'
    }))
    vm.carousels[0].is_open = true
  }

  vm.deselectSubscription = function (banner, subscription, form) {
    form.$setDirty()
    form.subscription.$setTouched()
    banner.subscriptions = banner.subscriptions.filter(s => s.id !== subscription.id)
    vm.updateBC(banner)
    banner.$listOfSubscriptions.shift()
    banner.$listOfSubscriptions = banner.$listOfSubscriptions.concat([subscription])
    if (banner.$listOfSubscriptions.length) {
      banner.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(banner.$listOfSubscriptions)
    } else {
      banner.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
    }
    vm.carousels.forEach(carousel => {
      if (!banner.$listOfSubscriptions.filter(s => s.id > 0).length && !carousel.subscription.length) {
        carousel.$listOfSubscriptions = []
      } else {
        carousel.$listOfSubscriptions = banner.$listOfSubscriptions
      }
    })

    banner.bannerBundles = banner.bannerBundles.filter(bb => {
      if (['CATEGORY', 'SUBCATEGORY'].includes(bb.contentType)) {
        return true
      }
      return !!bb.inSubscriptions.filter(sid => {
        return !!banner.subscriptions.find(s => s.id === sid)
      }).length
    })
    if (banner.subscriptions.length) {
      Banner.getPlatforms(vm.pckg.id, banner.subscriptions.map(s => s.id)).then(res => {
        banner.bannerBundles = banner.bannerBundles.filter(bb => {
          if (['CATEGORY', 'SUBCATEGORY'].includes(bb.contentType)) {
            return true
          }
          return !!bb.platformTypes.find(platform => {
            return res.includes(platform)
          }).length
        })
      })
    }
  }

  vm.selectSubscription = function (banner, form) {
    form.$setDirty()
    if (banner.$selectedSubscription.id === 0) {
      banner.$listOfSubscriptions.shift()
      banner.subscriptions = banner.subscriptions.concat(banner.$listOfSubscriptions)
      banner.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
    } else if (banner.$selectedSubscription.id === -1) {
      banner.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(banner.subscriptions)
      banner.subscriptions = []
      banner.bannerBundles = []
    } else {
      banner.subscriptions.push(banner.$selectedSubscription)
      banner.$listOfSubscriptions.shift()
      banner.$listOfSubscriptions = banner.$listOfSubscriptions.filter(s => !banner.subscriptions.find(sub => sub.id === s.id))
      if (banner.$listOfSubscriptions.length) {
        banner.$listOfSubscriptions = [{
          id: 0,
          name: 'All Subscriptions'
        }].concat(banner.$listOfSubscriptions.filter(s => !banner.subscriptions.find(sub => sub.id === s.id)))
      } else {
        banner.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
      }
    }
    vm.updateBC(banner)
    vm.carousels.forEach(carousel => {
      if (banner.$listOfSubscriptions[0].id === -1 && !carousel.subscriptions.length) {
        carousel.$listOfSubscriptions = []
      } else {
        carousel.$listOfSubscriptions = banner.$listOfSubscriptions
      }
    })
  }

  vm.atLeastOneSubscription = function (ba) {
    return ba.subscriptions.length > 0
  }

  vm.carouselSubscriptions = function (banner) {
    return banner.subscriptions.map(s => s.name).join(', ')
  }

  /**
   * Delete carousel
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   */
  vm.delete = function (carousel, index) {
    carousel.$listOfSubscriptions.shift()
    carousel.$listOfSubscriptions = carousel.$listOfSubscriptions.concat(carousel.subscriptions)
    if (carousel.$listOfSubscriptions.length) {
      carousel.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(carousel.$listOfSubscriptions)
    } else {
      carousel.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
    }
    if (carousel.id) {
      carousel.$action = 'delete'
      vm.carousels.forEach(c => {
        c.$listOfSubscriptions = carousel.$listOfSubscriptions
      })
    } else {
      vm.carousels.splice(index, 1)
      vm.carousels.forEach(c => {
        c.$listOfSubscriptions = carousel.$listOfSubscriptions
      })
    }
  }

  vm.filterDeleted = function (obj) {
    return obj.$action !== 'delete'
  }

  /**
   * Show delete button for carousel
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   */
  vm.showDeleteButton = function (carousel) {
    return authSvc.hasAccess('deleteBannerCarousel') || !carousel.id
  }

  /**
   * Add Banner Bundle (with modal)
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   */
  vm.addBannerBundle = vm.editBannerBundle = function (ba, bb, $event, form) {
    vm.stopEvent($event)

    const isNew = !bb
    const initialBb = angular.copy(bb) // initial state
    $uibModal.open({
      templateUrl: 'components/packages/views/addBannerBundle.html',
      controller: 'AddBannerBundleCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        banner: function () { return ba },
        bb: function () {
          return !isNew
            ? bb
            : new BannerBundle({ $carouselId: ba.id, networkId: vm.pckg.id, subscriptionId: ba.subscriptionId })
        },
        isNew: () => isNew,
        contentTypes: () => cts
      }
    }).result
      .then(
        function close (data) {
          if (data.action === 'delete') {
            const index = ba.bannerBundles.findIndex((item) => item.id === bb.id)
            ba.bannerBundles.splice(index, 1)
          } else {
            if (['TV_CHANNEL', 'TV_SHOW', 'MOVIE'].includes(data.bb.contentType)) {
              Banner.getSubscriptionsByContent(vm.pckg.id, data.bb.$content.id, data.bb.contentType).then(res => {
                data.bb.inSubscriptions = res
                if (isNew) {
                  ba.bannerBundles.push(data.bb)
                }
              })
            } else {
              if (isNew) {
                ba.bannerBundles.push(data.bb)
              }
            }
          }
          vm.updateBC(ba)
          form.$setDirty()
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialBb, bb) // restore bundles
          }
        })
  }

  /**
   * Delete banner bundle
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   * @param {model.Banner} ba - entity
   * @param {Number} index
   * @param {Object} form
   */
  vm.deleteBannerBundle = function (ba, index, form) {
    form.$setDirty()
    ba.bannerBundles.splice(index, 1)
    vm.updateBC(ba)
  }

  /**
   * On/Off episode
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   * @param {model.BannerBundle} bb - entity
   */
  vm.onOff = function (bb) {
    return bb._onOff()
  }

  /**
   * Create/update Banner
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   */
  vm.saveBanners = function (reassignSubscriptions = false) {
    // banners block start
    const deletedBanners = []
    const deletedPromises = []
    const banners = []
    const bannersPromises = []
    let abortByBanners = false
    vm.carousels.forEach(c => {
      if (!c.bannerBundles.length && c.$action !== 'delete') {
        c.$hasError = true
        abortByBanners = true
      }
      c.bannerBundles.forEach((bb, index) => {
        bb.sortOrder = index
      })
      if (c.$action === 'delete') {
        deletedBanners.push(c)
      } else if (c.$action) {
        banners.push(c)
      }
    })
    if (abortByBanners) return
    if (deletedBanners.length) {
      deletedBanners.forEach(db => {
        deletedPromises.push(db._delete(null))
      })
      return Promise.all(deletedPromises).then(() => {
        if (banners.length) {
          banners.forEach(banner => {
            bannersPromises.push(
              banner._save(data => {
                data.bannerBundles.forEach(bb => {
                  delete bb.inSubscriptions
                })
                data.reassignSubscriptions = reassignSubscriptions
                return data
              }, null, null, null, true)
            )
          })
          return Promise.all(bannersPromises).then((res) => {
            if (res.find(r => r.status === 'rejected')) {
              res.forEach((r, i) => {
                if (r.status === 'rejected') {
                  banners[i].$hasServerError = true
                  banners[i].$serverError = r.reason.data
                }
              })
              return 'error'
            } else {
              return 'updated banners'
            }
          })
        } else {
          return 'updated banner'
        }
      })
    } else if (banners.length) {
      banners.forEach(banner => {
        bannersPromises.push(
          banner._save(data => {
            data.bannerBundles.forEach(bb => {
              delete bb.inSubscriptions
            })
            data.reassignSubscriptions = reassignSubscriptions
            return data
          }, null, null, null, true)
        )
      })
      return Promise.allSettled(bannersPromises).then((res) => {
        if (res.find(r => r.status === 'rejected')) {
          res.forEach((r, i) => {
            if (r.status === 'rejected') {
              banners[i].$hasServerError = true
              banners[i].$serverError = r.reason.data
            }
          })
          return 'error'
        } else {
          return 'updated banners'
        }
      })
    }
  }

  vm.saveFeaturedRows = function (reassignSubscriptions = false) {
    const deletedFeatured = []
    const deletedPromises = []
    const featuredRows = []
    const featuredPromises = []
    vm.featuredCarousels.forEach(fc => {
      if (fc.$action === 'delete') {
        deletedFeatured.push(fc)
      } else if (fc.$action) {
        featuredRows.push(fc)
      }
    })
    if (deletedFeatured.length) {
      deletedFeatured.forEach(df => {
        deletedPromises.push(Featured.deleteFeatured(vm.pckg.id, df.subscriptions.map(s => s.id)))
      })
      return Promise.all(deletedPromises).then(() => {
        if (featuredRows) {
          featuredRows.forEach(featured => {
            featuredPromises.push((vm.newCarousel(featured) ? $http.post : $http.put)(`api/networks/${vm.pckg.id}/subscriptions/carousels/featured`, {
              carousels: vm.content_types.map(ct => {
                const { type, id, enabled, enabledOnModulePage, contentItems } = featured.carousels[ct]
                return {
                  type,
                  id,
                  enabled,
                  enabledOnModulePage,
                  platformTypes: featured.carousels[ct].$platforms.filter(p => p.checked).map(p => p.name),
                  contentItems: contentItems.map((ci, index) => {
                    return { ...ci, order: index, contentType: type }
                  })
                }
              }),
              subscriptions: featured.subscriptions.map(s => ({ id: s.id })),
              reassignSubscriptions
            }))
          })
          return Promise.all(featuredPromises).then(() => {
            return 'updated featured'
          })
        } else {
          return 'updated featured'
        }
      })
    } else if (featuredRows.length) {
      featuredRows.forEach(featured => {
        featuredPromises.push((vm.newCarousel(featured) ? $http.post : $http.put)(`api/networks/${vm.pckg.id}/subscriptions/carousels/featured`, {
          carousels: vm.content_types.map(ct => {
            const { type, id, enabled, enabledOnModulePage, contentItems } = featured.carousels[ct]
            return {
              type,
              id,
              enabled,
              enabledOnModulePage,
              platformTypes: featured.carousels[ct].$platforms.filter(p => p.checked).map(p => p.name),
              contentItems: contentItems.map((ci, index) => {
                return { ...ci, order: index, contentType: type }
              })
            }
          }),
          subscriptions: featured.subscriptions.map(s => ({ id: s.id })),
          reassignSubscriptions
        }))
      })
      return Promise.all(featuredPromises).then(() => {
        return 'updated featured'
      })
    }
  }

  vm.saveShelves = function () {
    const promises = []

    for (const shelfType in scope.shelves) {
      for (const shelf of scope.shelves[shelfType]) {
        switch (shelf.$action) {
          case 'delete':
            promises.push(Shelf._delete(shelf))
            break
          case 'create':
            promises.push(Shelf._create(shelf))
            break
          case 'update':
            promises.push(Shelf._update(shelf))
            break
        }
      }
    }

    return Promise.all(promises).then(() => 'update shelves')
  }

  vm.saveHints = function () {
    if (!scope.aiHintsCtrl || !scope.aiHintsCtrl.hints) {
      return Promise.resolve()
    }
    if (!pckg || !pckg.id) {
      return Promise.resolve()
    }
    if (scope.aiHintsCtrl.hints.some(hint => !hint.hintValue || hint.hintValue.length < 3 || hint.hintValue.length > 36)) {
      return Promise.reject({ data: 'Promotion not updated. Search Suggestions length must be from 3 to 36 chars' })
    }
    return $http.put(`api/networks/${pckg.id}/search-hint`, scope.aiHintsCtrl.hints)
      .then(() => 'update hints')
      .catch(() => 'error')
  }

  vm.savePromotion = function (forms) {
    const enabledForms = forms.filter(form => form)
    enabledForms.forEach(form => { form.$setSubmitted() })
    if (enabledForms.some(form => form.$invalid)) { return }
    vm.setDisable()
    if (!window.ENV.APP_MOVIE_OF_THE_NIGHT_API_KEY_EDIT_ENABLED && vm.motn && vm.motn.apiKeyExists && vm.motn.apiKey === '' && motnApiKeyAtLoad) {
      vm.motn.apiKey = motnApiKeyAtLoad
    }
    Promise.all([vm.saveShelves(), vm.saveBanners(), vm.saveFeaturedRows(), vm.saveHints(), MovieOfTheNight._update(vm.motn)]).then(res => {
      if (res.every(r => r !== 'error')) {
        alertLiteSvc.alert('Promotion updated', 'success')
        vm.location.reload()
      } else {
        alertLiteSvc.alert('Promotion not updated', 'error')
      }
    }).catch((err) => {
      alertLiteSvc.alert(err.data, 'error')
    }).finally(() => {
      vm.unsetDisable()
    })
  }

  /**
   * Link to hasAccess authSvc
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   */
  vm.hasAccess = authSvc.hasAccess

  vm.hasFewAccess = function (permissions) {
    return permissions.reduce((accumulator, permission) => {
      return accumulator && authSvc.hasAccess(permission)
    }, true)
  }

  /**
   * Count of selected bundles
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   * @param bundles
   * @returns Number
   */
  vm.countSelectedItems = function (bundles = []) {
    return bundles.filter(item => item.$highlighted).length
  }
  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    link.selected = true
    return list.filter(link => link.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list = list.filter(item => !item.selected)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => {
      item.selected = false
    })
    list.dragging = false
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index, ba, form) {
    form.$setDirty()
    if (items.filter((i) => i.$carouselId === ba.id).length !== items.length) {
      return false
    }
    if (list.length < index) {
      return false
    }
    vm.updateBC(ba)
    items.forEach(item => { item.selected = false })
    list = list
      .slice(0, index)
      .concat(items)
      .concat(list.slice(index))
    ba.bannerBundles = list.filter(item => !item.selected)
      .map(item => item instanceof BannerBundle ? item : new BannerBundle(Object.assign(item, { $carouselId: ba.id })))
    return true
  }

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onFeaturedDrop = function (list, items, index, fr, form) {
    vm.updateFR(fr)
    form.$setDirty()
    items.forEach(item => { item.selected = false })
    list.contentItems = list.contentItems
      .slice(0, index)
      .concat(items)
      .concat(list.contentItems.slice(index))
    list.contentItems = list.contentItems.filter(item => !item.selected)
    return true
  }

  /**
   * Check exist platforms into banner bundle
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   */
  vm.isEmptyPlatforms = function (ba) {
    return !!ba.bannerBundles.filter((bb) => !bb.platformTypes.length).length
  }

  vm.imgUrl = function (link) {
    return link.imageUrl
      ? link.imageUrl.indexOf('{{size}}') > -1
        ? link.imageUrl.replace('{{size}}', link.contentType === 'TV_CHANNEL' ? '56x56' : '210x118')
        : link.imageUrl + (link.imageUrl.indexOf('?') === -1 ? '?resize=210x118' : '&resize=210x118')
      : ''
  }

  /**
   * Check autoScrollEnabled handler
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   */
  vm.checkScroll = (ba) => {
    if (!ba.autoScrollEnabled) {
      ba.autoScrollIn = 5
    }
    vm.updateBC(ba)
  }

  /**
   * On/Off carousel
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   * @params carousel Banner
   * @params event
   */
  vm.onOffCarousel = function (carousel, $event) {
    vm.stopEvent($event)

    if (!vm.hasAccess('editBannerCarousel')) return

    carousel.enabled = !carousel.enabled
    vm.updateBC(carousel)
  }

  // Feature carousel block

  /**
   * Map Types
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   * @type {Object}
   */
  vm.contentTypes = {
    TV_CHANNEL: 'Channels',
    TV_SHOW: 'TV Shows',
    VOD: 'Movies'
  }

  vm.content_types = Object.keys(vm.contentTypes)

  /**
   * Available platforms
   *
   * @memberof mwApp/promotion.controller:FeaturedCarouselCtrl
   * @type []
   */
  vm.availablePlatforms = []

  /**
   * Default values for table state
   *
   * @type {Object}
   */
  const defaultFFTableState = {
    page: 0,
    count: 99,
    q: '',
    last: false
  }

  vm.featuredState = angular.copy(defaultFFTableState)

  if (authSvc.hasAccess('editFeaturedCarousel')) {
    Featured.getContentTypes(vm.pckg.id).then(data => {
      vm.availableTypes = data
    })
  }

  /**
   * Prepare carousel
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   * @param carousel
   * @param platforms
   */
  vm.prepareCarousel = function (carousel, platforms) {
    const newCarousel = new FeaturedCarousel({ ...carousel, networkId: pckg.id })
    newCarousel.$platforms = newCarousel._enhancePlatforms(['STB'], platforms)
    return newCarousel
  }

  // load banner info
  Featured.loadAll({ networkId: vm.pckg.id, params: vm.featuredState })
    .then((res) => {
      vm.currentCarousels = res.content.filter(c => c.subscriptions.length)
      vm.featuredCarousels = []
      vm.loadedFeatured = true
      let length = vm.currentCarousels.length
      let $listOfSubscriptions
      if (featuredSubscriptions.length) {
        $listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(featuredSubscriptions)
      } else {
        $listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
      }
      while (length > 0) {
        const currentSubscriptionId = vm.currentCarousels[0].subscriptions[0].id
        const carouselsArr = vm.currentCarousels.filter(carousel => carousel.subscriptions.find(s => s.id === currentSubscriptionId)).map(c => new FeaturedCarousel({
          ...c,
          networkId: vm.pckg.id
        }))
        const carousels = {}
        vm.content_types.forEach(ct => {
          carousels[ct] = carouselsArr.find(ca => ca.type === ct)
        })

        vm.featuredCarousels.push(new Featured({
          networkId: vm.pckg.id,
          carousels,
          subscriptions: carouselsArr[0].subscriptions,
          $listOfSubscriptions
        }))

        vm.currentCarousels = vm.currentCarousels.filter(carousel => !carousel.subscriptions.find(s => s.id === currentSubscriptionId))
        length = vm.currentCarousels.length
      }
      vm.featuredState.last = res.last
    })

  /**
   * On/Off carousel
   *
   * @memberof mwApp/promotion.controller:PromotionCtrl
   * @params carousel FeaturedCarousel
   * @params event
   */
  vm.onOffFeaturedRow = function (carousel, featured, form) {
    if (vm.hasFewAccess(['editFeaturedCarousel', 'editNetwork'])) {
      carousel.enabled = !carousel.enabled
      form.$setDirty()
      vm.updateFR(featured)
    }
  }

  vm.selectSubscriptionFR = function (featured, form) {
    form.$setDirty()
    vm.updateFR(featured)
    if (featured.$selectedSubscription.id === 0) {
      featured.$listOfSubscriptions.shift()
      featured.subscriptions = featured.subscriptions.concat(featured.$listOfSubscriptions)
      featured.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
    } else if (featured.$selectedSubscription.id === -1) {
      featured.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(featured.subscriptions)
      featured.subscriptions = []
      vm.content_types.forEach(ct => {
        featured.carousels[ct].contentItems = []
      })
    } else {
      featured.subscriptions.push(featured.$selectedSubscription)
      featured.$listOfSubscriptions.shift()
      featured.$listOfSubscriptions = featured.$listOfSubscriptions.filter(s => !featured.subscriptions.find(sub => sub.id === s.id))
      if (featured.$listOfSubscriptions.length) {
        featured.$listOfSubscriptions = [{
          id: 0,
          name: 'All Subscriptions'
        }].concat(featured.$listOfSubscriptions.filter(s => !featured.subscriptions.find(sub => sub.id === s.id)))
      } else {
        featured.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
      }
    }
    vm.featuredCarousels.forEach(f => {
      if (featured.$listOfSubscriptions[0].id === -1 && !f.subscriptions.length) {
        f.$listOfSubscriptions = []
      } else {
        f.$listOfSubscriptions = angular.copy(featured.$listOfSubscriptions)
      }
    })

    if (featured.subscriptions.length) {
      Featured.getPlatforms(vm.pckg.id, featured.subscriptions.map(s => s.id)).then(res => {
        vm.content_types.forEach(ct => {
          featured.carousels[ct].$platforms = featured.carousels[ct]._enhancePlatforms(['STB'], res)
        })
      })
    } else {
      vm.content_types.forEach(ct => {
        featured.carousels[ct].$platforms = []
      })
    }
  }

  vm.deselectSubscriptionFR = function (featured, subscription, form) {
    form.$setDirty()
    vm.updateFR(featured)
    form.subscription.$setTouched()
    featured.subscriptions = featured.subscriptions.filter(s => s.id !== subscription.id)
    featured.$listOfSubscriptions.shift()
    featured.$listOfSubscriptions = featured.$listOfSubscriptions.concat([subscription])
    if (featured.$listOfSubscriptions.length) {
      featured.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(featured.$listOfSubscriptions)
    } else {
      featured.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
    }
    vm.featuredCarousels.forEach(f => {
      f.$listOfSubscriptions = angular.copy(featured.$listOfSubscriptions)
    })
    if (featured.subscriptions.length) {
      Featured.getPlatforms(vm.pckg.id, featured.subscriptions.map(s => s.id)).then(res => {
        vm.content_types.forEach(ct => {
          featured.carousels[ct].$platforms = featured.carousels[ct]._enhancePlatforms(['STB'], res)
        })
      })
    } else {
      vm.content_types.forEach(ct => {
        featured.carousels[ct].$platforms = []
      })
    }
    vm.content_types.forEach(ct => {
      featured.carousels[ct].contentItems = featured.carousels[ct].contentItems.filter(ci => !!ci.inSubscriptions.filter(s => s !== subscription.id).length)
    })
  }

  /**
   * Check, if at least one platform is selected
   * @return {Boolean}
   */
  vm.atLeastOnePlatform = function (carousel) {
    if (!carousel) {
      return false
    }

    if (vm.hasFewAccess(['editFeaturedCarousel', 'editNetwork'])) {
      for (let i = carousel.$platforms.length; i--;) {
        if (carousel.$platforms[i].checked) {
          return true
        }
      }
      return false
    }
    return true
  }

  vm.getAvailablePlatforms = function (featured) {
    if (!featured.$gettedPlatforms && featured.subscriptions.length) {
      featured.$gettedPlatforms = true
      Featured.getPlatforms(vm.pckg.id, featured.subscriptions.map(s => s.id)).then(res => {
        vm.content_types.forEach(type => {
          const carousel = vm.prepareCarousel(featured.carousels[type], res)
          featured.carousels[type].$platforms = carousel.$platforms
          featured.carousels[type].networkId = carousel.networkId
        })
      })
    }
  }

  /**
   * Create/Update pricing
   *
   * @memberof mwApp/packages.controller:SubscriptionContentSetsCtrl
   * @function
   * @param carousel
   * @param featured
   */
  vm.addFeatureRowItems = function (carousel, featured) {
    if (featured.subscriptions.length === 0) return
    const initialItems = angular.copy(carousel.contentItems || [])
    $uibModal.open({
      templateUrl: 'components/packages/views/addFeaturedRowItems.html',
      controller: 'AddFeaturedRowItemsCtrl as vm',
      animation: false,
      size: 'xl',
      resolve: {
        carousel: function () {
          return carousel
        },
        type: function () {
          return carousel.type
        },
        contentItems: function () {
          return carousel.contentItems || []
        },
        subscriptionIds: function () {
          return featured.subscriptions.map(s => s.id)
        }
      }
    }).result
      .then(
        function close (contentItems) {
          carousel.contentItems = angular.copy(contentItems)
          vm.updateFR(featured)
        },
        function dismiss () {
          angular.copy(initialItems, carousel.contentItems)
        })
  }

  /**
   * Delete contentItem from carousel
   *
   * @memberof mwApp/packages.controller:FeaturedCarouselCtrl
   * @param item
   * @param carousel FeaturedCarousel
   * @param featured Featured
   * @param form
   */
  vm.deleteItem = function (item, carousel, featured, form) {
    form.$setDirty()
    vm.updateFR(featured)
    carousel.contentItems = carousel.contentItems.filter(i => i.contentId !== item.contentId)
  }

  /**
   * Delete featured
   *
   * @memberof mwApp/packages.controller:PromotionCtrl
   */
  vm.deleteFR = function (featured, index) {
    featured.$listOfSubscriptions.shift()
    featured.$listOfSubscriptions = featured.$listOfSubscriptions.concat(featured.subscriptions)
    if (featured.$listOfSubscriptions.length) {
      featured.$listOfSubscriptions = [{ id: 0, name: 'All Subscriptions' }].concat(featured.$listOfSubscriptions)
    } else {
      featured.$listOfSubscriptions = [{ id: -1, name: 'Deselect all Subscriptions' }]
    }
    if (vm.newCarousel(featured)) {
      vm.featuredCarousels.splice(index, 1)
      vm.featuredCarousels.forEach(carousel => {
        carousel.$listOfSubscriptions = angular.copy(featured.$listOfSubscriptions)
      })
    } else {
      featured.$action = 'delete'
      vm.featuredCarousels.forEach(carousel => {
        carousel.$listOfSubscriptions = angular.copy(featured.$listOfSubscriptions)
      })
    }
  }

  vm.newCarousel = function (featured) {
    return !vm.content_types.find(type => featured.carousels[type].id)
  }

  vm.addFeaturedCarousel = function () {
    let subscriptionsForFeatured
    if (!vm.featuredCarousels.length) {
      subscriptionsForFeatured = [{ id: 0, name: 'All Subscriptions' }].concat(featuredSubscriptions)
    } else {
      if (vm.featuredCarousels[0].$listOfSubscriptions.filter(s => s.id > 0).length) {
        subscriptionsForFeatured = angular.copy(vm.featuredCarousels[0].$listOfSubscriptions)
      } else {
        subscriptionsForFeatured = []
      }
    }
    const carousels = {}
    vm.content_types.forEach(type => {
      carousels[type] = new FeaturedCarousel({ type, networkId: vm.pckg.id })
    })
    vm.featuredCarousels.unshift(new Featured({
      $listOfSubscriptions: subscriptionsForFeatured,
      networkId: vm.pckg.id,
      carousels,
      $action: 'post'
    }))
    vm.featuredCarousels[0].is_open = true
  }

  vm.loadIcon = function (key) {
    if (key) {
      return require('../../img/icons/' + key + '.svg')
    } else {
      return ''
    }
  }

  vm.disabledPromotion = function () {
    if (vm.featuredCarousels && vm.featuredCarousels.length) {
      vm.abortByFR = false
      vm.featuredCarousels.forEach(fc => {
        if (fc.$action && fc.$action !== 'delete') {
          fc.$hasError = false
          vm.content_types.forEach(ct => {
            if (fc.carousels[ct].contentItems.length > 36 || !vm.atLeastOnePlatform(fc.carousels[ct])) {
              fc.carousels[ct].$hasError = true
              fc.$hasError = true
              vm.abortByFR = true
            } else {
              fc.carousels[ct].$hasError = false
            }
          })
        }
      })

      vm.abortByBC = vm.carousels.some(carousel => {
        return carousel.$hasError && carousel.$action !== 'delete'
      })

      vm.updatedFR = vm.featuredCarousels.some(fc => {
        return fc.$action
      })
    }
    vm.updatedBC = vm.carousels.some(c => {
      return !!c.$action
    })
    const abortByHints = scope.aiHintsCtrl?.hints.some(hint => hint.editing)

    return !(vm.updatedBC || vm.updatedFR || scope.updatedShelves || scope.updatedHints || vm.nightForm.$dirty) || vm.abortByFR || vm.abortByBC || abortByHints
  }

  vm.updateFR = function (featured) {
    if (!vm.newCarousel(featured)) {
      featured.$action = 'put'
    }
    featured.$updated = true
  }

  vm.updateBC = function (carousel) {
    if (carousel.id) {
      carousel.$action = 'put'
    }
    carousel.$hasServerError = false
    carousel.$updated = true
  }

  vm.showBCError = function (carousel) {
    if (carousel.$updated &&
      (carousel.$hasServerError ||
        vm.isEmptyPlatforms(carousel) ||
        !vm.atLeastOneSubscription(carousel) ||
        !carousel.bannerBundles.length ||
        carousel.bannerBundles.some(bb => vm.showBCItemError(bb)) ||
        (carousel.autoScrollEnabled &&
          (!carousel.autoScrollIn || carousel.autoScrollIn < 1 || carousel.autoScrollIn > 60)))) {
      carousel.$hasError = true
      return true
    }
    carousel.$hasError = false
    return false
  }

  vm.showBCItemError = function (item) {
    return item.$content && ((item.$content.id && !item.$content.name) || (item.$content.name && !item.$content.enabled))
  }

  vm.selectRow = function (link) {
    if (vm.rowForm.$invalid) { return }
    vm.selectedRow = link
  }

  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.pckg._publicListUrl)
    }
  }

  $scope.$watch('vm.featuredCarousels.length', () => {
    if (vm.featuredCarousels) {
      vm.featuredCarousels.forEach((featured, index) => {
        featured.$index = index
      })
    }
  })
}
